module.exports = __webpack_public_path__ + "media/images/awards/pattern-eabf52dd9b809c7ffc18458e1a8f4f1d.png";